export default __webpack_public_path__ + "static/media/Stryker.1e0c48f4.webp";